// The app's mark, from HanDu/DesignSystem/HanDuLogo.swift: a red lacquer seal
// with a gold hairline border, like a traditional Chinese name/luck seal.
// Drawn rather than rasterised there, and drawn here too — so it stays crisp
// at any size and tracks the brand colours from one place.
export default function HanDuLogo({ size = 76, className = '' }) {
  // Everything scales off the edge length so the mark keeps its proportions,
  // matching the ratios in the Swift view (radius 12/76, border 2/76,
  // glyph 38/76).
  const style = {
    width: size,
    height: size,
    borderRadius: size * (12 / 76),
    borderWidth: Math.max(1, size * (2 / 76)),
    boxShadow: `0 ${size * (4 / 76)}px ${size * (12 / 76)}px rgba(192, 57, 43, 0.30)`,
  }

  return (
    <div
      className={`grid shrink-0 place-items-center border-handu-gold bg-handu-container ${className}`}
      style={style}
      role="img"
      aria-label="HanDu"
    >
      <span
        className="hanzi font-semibold leading-none text-white"
        style={{ fontSize: size * (30 / 76) }}
      >
        汉读
      </span>
    </div>
  )
}
